export { default as ReadabilityScoreAggregator } from "./ReadabilityScoreAggregator";
export { default as ScoreAggregator } from "./ScoreAggregator";
export { default as SEOScoreAggregator } from "./SEOScoreAggregator";
